import Reveal from "./Reveal";

interface FeatureRowProps {
  mainText: string;
  subText: string;
  image: string;
  reverse?: boolean;
}

const FeatureRow = ({ mainText, subText, image, reverse = false }: FeatureRowProps) => {
  return (
    <div
      className={`mx-auto mb-16 flex w-full max-w-5xl items-center gap-10 max-sm:mb-10 max-sm:flex-col ${
        reverse ? "flex-row-reverse" : ""
      }`}
    >
      <Reveal className="w-1/2 max-sm:w-full" y={reverse ? -28 : 28}>
        <div className="overflow-hidden rounded-2xl ring-1 ring-white/10">
          <img
            src={image}
            alt={mainText}
            className="h-[280px] w-full object-cover transition-transform duration-700 hover:scale-105 max-sm:h-[200px]"
          />
        </div>
      </Reveal>
      <Reveal className="w-1/2 max-sm:w-full max-sm:text-center" delay={100}>
        <h3 className="mb-3 text-[24px] font-bold leading-tight text-white max-sm:text-[20px]">
          {mainText}
        </h3>
        <p className="text-[15px] leading-relaxed text-white/60">{subText}</p>
      </Reveal>
    </div>
  );
};

export default FeatureRow;
